import { DpFanDialogProgressBar } from '@/components/blocks/DpFanDialog/parts/DpFanDialogProgressBar';
import { Img } from '@/components/blocks/MaterialImage';
import { Box } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';

interface IDpFanDialogHeader {
	percent?: number;
	onClose?: () => void;
}

export const DpFanDialogHeader = ({ percent = 0, onClose }: IDpFanDialogHeader) => {
	return (
		<Box
			sx={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				gap: '35px',
			}}
		>
			<DpFanDialogProgressBar percent={percent} frameSx={{ display: { xs: 'none', md: 'flex' } }} />
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					paddingX: { xs: '0px', md: '40px' },
				}}
			>
				<Box />
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/images/logo.png"
					alt="wand-big"
					sx={{
						width: '174px',
						display: { xs: 'none', md: 'flex' },
					}}
				/>
				<ClearIcon
					sx={{
						color: { xs: '#2C2C2C', md: '#333333' },
						fontSize: { xs: '24px', md: '32px' },
						cursor: 'pointer',
						position: { xs: 'absolute', md: 'relative' },
						top: { xs: '16px', md: 'auto' },
						right: { xs: '16px', md: 'auto' },
					}}
					onClick={onClose}
				/>
			</Box>
		</Box>
	);
};
